<template>
  <div class="lease-scheme-campaign">
    <el-form label-position="top" class="form-box">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="租期赠送">
            <div class="campaign-select-wrap">
              <el-input
                :value="selectedCampaignNames"
                disabled
                placeholder="请选择活动"
                class="campaign-name-input"
              />
              <el-button
                type="primary"
                size="small"
                :disabled="disabled"
                @click="openCampaignList"
              >选择</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      :visible.sync="dialogVisible"
      :title="currentView === 'list' ? '选择租期赠送活动' : '新建租期赠送活动'"
      :width="dialogWidth"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="campaign-select-dialog"
    >
      <!-- 列表视图 -->
      <template v-if="currentView === 'list'">
        <div class="campaign-list-dialog">
          <div v-loading="listLoading" class="campaign-list-scroll">
            <el-checkbox-group v-model="tempSelectedIds" class="campaign-checkbox-group">
              <div
                v-for="item in campaignList"
                :key="item.id"
                :class="['campaign-item', { 'is-selected': tempSelectedIds.includes(item.id) }]"
              >
                <el-checkbox :label="item.id" class="campaign-checkbox">
                  <div class="campaign-item__content">
                    <div class="campaign-item__title">{{ item.activityName }}</div>
                    <div class="campaign-item__date">
                      {{ item.startDate }} 至 {{ item.endDate }} ·
                      前置免租{{ item.preFreeRentDays }}天 ·
                      满赠{{ item.presentDays }}天
                    </div>
                  </div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <div class="campaign-add-link" @click="switchToCreate">
            + 新建活动
          </div>
        </div>
      </template>

      <!-- 新建视图 -->
      <template v-else>
        <CampaignForm
          ref="createCampaignFormRef"
          v-model="newCampaignData"
          mode="create"
          :hide-bind-plan="true"
        />
      </template>

      <div slot="footer" class="dialog-footer">
        <template v-if="currentView === 'list'">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click="confirmSelectCampaigns"
          >确定</el-button>
        </template>
        <template v-else>
          <el-button @click="currentView = 'list'">取消</el-button>
          <el-button type="primary" :loading="createLoading" @click="saveNewCampaign">保存</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCampaignList, saveCampaignSignCheck } from '@/api/domain/activity'
import CampaignForm from '@/components/CampaignForm.vue'
import { CAMPAIGN_STATUS } from '@/pages/activity/leaseCampaign/leaseCampaignConst'

export default {
  name: 'LeaseSchemeCampaign',
  components: { CampaignForm },
  props: {
    value: { type: Array, default: () => [] },

    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      dialogVisible: false,
      currentView: 'list',
      listLoading: false,
      createLoading: false,
      campaignList: [],
      tempSelectedIds: [],
      newCampaignData: {},
      localValue: [],
      newlyCreatedId: null,
    }
  },
  computed: {
    selectedCampaignNames() {
      return this.localValue.map((v) => v.campaignName).join('、')
    },
    dialogWidth() {
      return '550px'
    },
  },
  watch: {
    value: {
      handler(val) {
        this.localValue = Array.isArray(val) ? val : []
      },
      immediate: true,
    },
  },
  methods: {
    async openCampaignList() {
      this.dialogVisible = true
      this.currentView = 'list'
      this.listLoading = true
      this.tempSelectedIds = this.localValue.map((v) => v.campaignId)
      const { code, data } = await getCampaignList({
        pageNum: 1,
        pageSize: 999,
      })
      if (code === 1) {
        const items = data?.items || []
        this.campaignList = items.filter(
          (item) => item.activityState === CAMPAIGN_STATUS.NOT_STARTED ||
            item.activityState === CAMPAIGN_STATUS.IN_PROGRESS,
        )
      }
      this.listLoading = false
      if (this.newlyCreatedId) {
        if (!this.tempSelectedIds.includes(this.newlyCreatedId)) {
          this.tempSelectedIds.push(this.newlyCreatedId)
        }
        this.newlyCreatedId = null
      }
    },

    confirmSelectCampaigns() {
      const selected = this.campaignList.filter((c) => this.tempSelectedIds.includes(c.id))

      for (let i = 0; i < selected.length; i++) {
        for (let j = i + 1; j < selected.length; j++) {
          const a = selected[i]
          const b = selected[j]
          if (a.startDate <= b.endDate && b.startDate <= a.endDate) {
            this.$message.error(`活动【${a.activityName}】与【${b.activityName}】的活动日期存在重叠，请重新选择`)
            return
          }
        }
      }

      this.emitSelection(selected)
    },

    emitSelection(campaigns) {
      const value = campaigns.map((c) => ({
        campaignId: c.id,
        campaignName: c.activityName,
      }))
      this.localValue = value
      this.$emit('input', value)
      this.dialogVisible = false
    },

    switchToCreate() {
      this.currentView = 'create'
      this.newCampaignData = {}
      this.$nextTick(() => {
        this.$refs.createCampaignFormRef?.resetFields()
      })
    },

    async saveNewCampaign() {
      const form = this.$refs.createCampaignFormRef
      if (!form) return
      try {
        await form.validate()
      } catch {
        return
      }

      const params = form.buildSaveParams()
      this.createLoading = true
      const { code, data, msg } = await saveCampaignSignCheck(params)
      if (code === 1) {
        this.$message.success('活动创建成功')
        this.newlyCreatedId = data
        this.openCampaignList()
      } else {
        this.$message.error(msg || '创建失败')
      }
      this.createLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.form-box {
  ::v-deep .el-form-item__label {
    justify-content: flex-start;
  }
}
.campaign-select-wrap {
  display: flex;
  gap: 12px;
  .campaign-name-input {
    flex: 1;
  }
}

.campaign-list-dialog {
  display: flex;
  flex-direction: column;
}

.campaign-list-scroll {
  overflow-y: auto;
  height: 200px;
}

.campaign-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.campaign-item {
  border: 1px solid #E5E6EB;
  border-radius: 6px;
  padding: 10px 14px;
  cursor: pointer;
  transition: border-color 0.2s;
  background: #fff;

  &:hover {
    border-color: #C9CDD4;
  }

  &.is-selected {
    border-color: #2A6BFF;
    background: #F2F7FF;
  }
}

.campaign-item__content {
  .campaign-item__title {
    font-size: 14px;
    font-weight: 500;
    color: #1D2129;
    margin-bottom: 2px;
    line-height: 22px;
  }

  .campaign-item__date {
    color: #86909C;
    font-size: 12px;
    line-height: 20px;
  }
}

.campaign-checkbox {
  display: flex !important;
  align-items: center;
  width: 100%;
  ::v-deep .el-checkbox__label {
    flex: 1;
    padding-left: 8px;
  }
}

.campaign-add-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 12px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
  padding: 10px 0;
  border: 1px solid #C9CDD4;
  border-radius: 6px;
  color: #333;

  &:hover {
    border-color: #2A6BFF;
    color: #2A6BFF;
    background: #F2F7FF;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
</style>

<style lang="scss">
.campaign-select-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #F2F3F5;
    padding-bottom: 16px;
  }

  .el-dialog__body {
    padding: 20px 24px;
  }
}
</style>
